import { useTranslation } from 'react-i18next'
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from '@/components/shadcn/table'
import { LoaderTable } from '@/components/common/loaders/LoaderTable'

interface Transaction {
  id: string
  creationTimestamp?: string
  transactionTimestamp?: string
  sourceWalletOwnerName?: string | null
  sourceWalletId?: string | null
  destinationWalletOwnerName?: string | null
  destinationWalletId?: string | null
  comment?: string | null
  amount?: number | null
  currency?: string | null
}

interface Props {
  isLoading: boolean
  isError?: boolean
  transactions: Transaction[]
}

function formatDate(ts?: string) {
  if (!ts) return '—'
  return new Date(ts.endsWith('Z') ? ts : ts + 'Z').toLocaleString('de-DE', {
    day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
  })
}

export function WalletTransactionsDataTable({ isLoading, isError, transactions }: Props) {
  const { t } = useTranslation('wallet')
  return (
    <Table>
      <TableHeader className="sticky top-0 z-10 bg-card shadow-sm [&_th]:bg-card">
        <TableRow>
          <TableHead>{t('table.columns.date')}</TableHead>
          <TableHead>{t('table.columns.bookingDate')}</TableHead>
          <TableHead>{t('table.columns.sourceWallet')}</TableHead>
          <TableHead>{t('table.columns.targetWallet')}</TableHead>
          <TableHead>{t('table.columns.reason')}</TableHead>
          <TableHead>{t('table.columns.amount')}</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        <LoaderTable isLoading={isLoading} isError={isError} isEmpty={transactions.length === 0} colSpan={6}>
          {transactions.map((tx) => (
          <TableRow key={tx.id}>
            <TableCell className="text-sm">{formatDate(tx.creationTimestamp)}</TableCell>
            <TableCell className="text-sm">{formatDate(tx.transactionTimestamp)}</TableCell>
            <TableCell className="text-sm text-muted-foreground">
              {tx.sourceWalletOwnerName ?? tx.sourceWalletId ?? '—'}
            </TableCell>
            <TableCell className="text-sm text-muted-foreground">
              {tx.destinationWalletOwnerName ?? tx.destinationWalletId ?? '—'}
            </TableCell>
            <TableCell className="text-sm text-muted-foreground max-w-50 truncate">
              {tx.comment ?? '—'}
            </TableCell>
            <TableCell className="text-sm font-medium tabular-nums">
              {tx.amount?.toLocaleString('de-DE')} {tx.currency ?? ''}
            </TableCell>
          </TableRow>
          ))}
        </LoaderTable>
      </TableBody>
    </Table>
  )
}
